import { useCallback, useEffect } from "react";
import { useAuthenticated } from "../../auth";
import { locationsUpdateInterval } from "../../config";
import { usePortalApi } from "../../db/portal-api";
import { useInterval } from "../../utils";
import { useDevicesStore } from "./store";
import type { DeviceLocation } from "./types";

export function LocationsProvider() {
  const { positionSehen } = useAuthenticated();
  return positionSehen ? <ActiveLocationsProvider /> : null;
}

function ActiveLocationsProvider() {
  const setDevices = useDevicesStore((state) => state.setDevices);
  const { portalKey } = useAuthenticated();
  const { useNewApi, baseUrl } = usePortalApi();

  const updateLocations = useCallback(async () => {
    // The legacy portal has no equivalent endpoint — simply don't fetch for it.
    if (!useNewApi || !baseUrl) {
      setDevices([]);
      return;
    }

    const response = await fetch(`${baseUrl}/api/device/locations`, {
      headers: { authorization: `Bearer ${portalKey}` },
    });
    if (!response.ok) {
      console.error(
        "Error getting device locations: {} {}",
        response.status,
        response.statusText,
      );
      return;
    }
    const data = await response.json();
    setDevices(
      (data.devices ?? []).map(
        (d: any): DeviceLocation => ({
          id: d.id,
          name: d.name,
          koordinaten: { latitude: d.lat, longitude: d.lng },
          accuracy: d.accuracy,
        }),
      ),
    );
  }, [useNewApi, baseUrl, portalKey, setDevices]);

  useInterval(updateLocations, locationsUpdateInterval);
  useEffect(() => {
    updateLocations();
  }, [updateLocations]);

  return null;
}
